export const parseFileNameWithTimestamp = (name: string) => {
  const nameParts = name.split('_')
  const fileTimestamp = nameParts[0] ?? ''
  const displayName = isNaN(Date.parse(fileTimestamp)) ? name : (nameParts[1] ?? name)
  return displayName
}

export const getBaseFileNameForComparison = (name: string): string => {
  const nameWithoutTimestamp = parseFileNameWithTimestamp(name)
  const duplicateCountPattern = /\s*\(\d+\)(?=\.[^.]+$|$)/
  return nameWithoutTimestamp.replace(duplicateCountPattern, '')
}
